import React from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { useTerms } from '@hooks'; 
import TermsItem from './TermsItem';
import { Footer } from '@components';
import { useSignup } from '@context/SignupContext';

function Terms() {
  const { setTermsAccepted, setAgreedTermIds  } = useSignup();
  const { data: terms = [], isLoading } = useTerms();
  const methods = useForm();
  const { setValue, watch, handleSubmit } = methods;
  const navigate = useNavigate();

  const values = watch();
  const allChecked =
    terms.length > 0 && terms.every(t => values[`t${t.termsId}`]);

  const toggleAll = e => {
    terms.forEach(t => setValue(`t${t.termsId}`, e.target.checked));
  };

  const onSubmit = () => {
    const requiredOK = terms
      .filter(t => t.required)
      .every(t => values[`t${t.termsId}`]);

    if (!requiredOK) {
      alert('필수 약관에 동의해주세요.');
      return;
    }

    const checkedIds = terms
    .filter(t => values[`t${t.termsId}`])
    .map(t => t.termsId);

    setAgreedTermIds(checkedIds);  
    setTermsAccepted(true);
    navigate('/signup');
  };

  if (isLoading) return <>Loading…</>;

  return (
    <main id="main" className="mainpage">
      <div>
        <div className="section main-contact">
          <div className="sub-tit-bg">
            <div className="container sub-h">
              <div className="sub-tit-01">
                <img src="/img/ico-home.png" alt="home" />
                회원가입 | 약관동의
              </div>
            </div>
          </div>

          <div className="sub-container">
            <div className="sub-layout">
              <div className="sub-contact">
                <h3 className="border-bt">회원가입</h3>

                <div style={{ padding: '10px' }}>
                  <FormProvider {...methods}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                      <ul className="member-box">
                        <li><span className="on">1</span>약관동의</li>
                        <li><span>2</span>정보입력</li>
                      </ul>

                      {/* 전체 동의 */}
                      <div className="agree-wrapper">
                        <div className="checkbox-mr">
                          <label htmlFor="checkbox-all" className="checkbox-label">
                            <input
                              id="checkbox-all"
                              type="checkbox"
                              className="inp-sel-sub"
                              checked={allChecked}
                              onChange={toggleAll}
                            />
                          </label>
                        </div>
                        <div className="agree-tit">
                          이용약관, 개인정보 수집 및 이용에 모두 동의합니다.
                        </div>
                      </div>

                      <p>* 전체 동의에는 필수 및 선택 동의가 포함됩니다.</p>

                      {/* 약관 1~4 */}
                      {terms.map(t => (
                        <TermsItem key={t.termsId} term={t} />
                      ))}

                      <div className="text-cent">
                        <button type="submit" className="btn btn-blue mt30 btn-big">
                          회원가입
                        </button>
                      </div>
                    </form>
                  </FormProvider>
                </div>
              </div>
            </div>
          </div>

          <Footer />
        </div>
      </div>
    </main>
  );
}

export default Terms;
